import { useSuspenseQuery } from "@apollo/client/react";

import {
  GetCategoryForTableViewDocument,
  type GetCategoryForTableViewQuery,
  type GetCategoryForTableViewQueryVariables,
} from "~/features/admin/categories/gqls";

/**
 * Hierarchical category list scoped by typeId (entity or relation). Excludes
 * deactivated rows so the tree/table tabs show the live shape of the database.
 */
export function useCategoryTableView(typeId: "entity" | "relation") {
  return useSuspenseQuery<GetCategoryForTableViewQuery, GetCategoryForTableViewQueryVariables>(
    GetCategoryForTableViewDocument,
    {
      variables: {
        where: {
          typeId: { _eq: typeId },
          deactivatedAt: { _isNull: true },
        },
      },
    },
  );
}
